import { PersonOutline } from "@mui/icons-material";
import { Button } from "@mui/material";
import { useState } from "react";
import ClientDetailsModal from "./ClientDetailsModal";

/**
 * Standard way to open client details from any module screen.
 * - `link`: inline name in subtitles (Tasks, Insurance header, etc.)
 * - `button`: outlined action beside a client selector
 */
const ViewClientProfile = ({
  clientId,
  clientName,
  variant = "link",
  size = "small",
  className = "",
  buttonLabel = "View client profile",
  displayName,
}) => {
  const [open, setOpen] = useState(false);

  if (!clientId) return null;

  const displayText = displayName || clientName || "View client";

  return (
    <>
      {variant === "link" ? (
        <button
          type="button"
          className={`text-primary hover:underline bg-transparent border-0 p-0 cursor-pointer ${className}`}
          onClick={() => setOpen(true)}
        >
          {displayText}
        </button>
      ) : (
        <Button
          variant="outlined"
          size={size}
          startIcon={<PersonOutline />}
          onClick={() => setOpen(true)}
          className={className}
          sx={{ flexShrink: 0, whiteSpace: "nowrap" }}
        >
          {buttonLabel}
        </Button>
      )}

      <ClientDetailsModal open={open} handleClose={() => setOpen(false)} clientId={clientId} />
    </>
  );
};

export default ViewClientProfile;
